import { render } from "./annotation-view.vue?vue&type=template&id=d9e746de&scoped=true&ts=true"
import script from "./annotation-view.ts?vue&type=script&lang=ts&external"
export * from "./annotation-view.ts?vue&type=script&lang=ts&external"

import "./annotation-view.scss?vue&type=style&index=0&id=d9e746de&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9e746de"]])

export default __exports__